<template>
  <div>
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>
    
    <div class="flex">
      <div class="w-full bg-primary">
        <div class="flex p-4">
          <div class="w-full">
            <div class="checkdiv mr-5">
              <i class="fa fa-check-circle" aria-hidden="true"></i>
            </div>
            <div class="importmsg p-3">
              <p class="text-4xl text-primary-invert">
                {{ $t('frontend_groovemail_contacts_step6_congratulations') }}
              </p>
              <p class="text-lg msgdesc">
                {{ $t('frontend_groovemail_contacts_step6_your_import') }}
                <br />
                {{ $t('frontend_groovemail_contacts_step6_and_willbe') }}
              </p>
              <!-- <p class="text-lg msgdesc"></p> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-5 autosec">
      <div class="flex mb-4">
        <div class="w-full bg-white  text-left">
          <div class="flex border-b border-grey-500 p-4">
            <div class="w-full">
              <p class="text-grey-700 font-semibold text-lg">
                {{ $t('frontend_groovemail_contacts_step6_what_next') }}
              </p>
            </div>
          </div>

          <div class="flex border-b border-grey-500 p-4">
            <div class="w-full">
              <div class="pull-left leftcol">
                <p class="text-grey-700 ">
                  {{ $t('frontend_groovemail_contacts_step6_do_you_want') }}
                </p>
              </div>
              <div class="pull-right rightcol mr-5">
                <gd-button
                  variant="primary"
                  @click="importcontacts()"
                  >
                  {{ $t('frontend_groovemail_contacts_step6_import_leads') }}
                  </gd-button
                >
              </div>
            </div>
          </div>

          <div class="flex border-b border-grey-500 p-4">
            <div class="w-full">
              <div class="pull-left leftcol">
                <p class="text-grey-700 ">
                  {{ $t('frontend_groovemail_contacts_step6_do_you_want_to') }}
                </p>
              </div>
              <div class="pull-right rightcol mr-5">
                <gd-button
                  variant="primary"
                  @click="returntoleads()"
                  >
                  {{ $t('frontend_groovemail_contacts_step6_return') }}
                  </gd-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>
<script>

import Swal from 'sweetalert2';
import themeConfig from '@/theme/themeConfig.js';
import {
  required,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators';
export default {
  name: 'step6',
  props: {
    model: {
      required: true
    }
  },
  data() {
    return {
      localModel: this.model,
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
    };
  },
  validations: {
    localModel: {
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      var isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },

    returntoleads() {
      this.$router.push({ name: 'Leads' });
    },

    importcontacts() {
      this.localModel.upload_contacts_data = [];
      this.localModel.importid = null;
      this.localModel.matchfields = [];
      this.localModel.importid = null;
      this.localModel.uploaded = null;
      this.localModel.failed = null;
      this.localModel.duplicated = null;
      this.localModel.blocked = null;
      this.localModel.alreadyexisitng = null;
      this.localModel.imported = null;
      this.localModel.selectedtagids = [];
      this.localModel.selectedlistids = [];
      this.localModel.selectedtags = [];
      this.localModel.selectedlists = [];
      this.localModel.currentTab = 'step1';
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    }
  }
};
</script>

